require('./src/styles/global.scss')
require("prismjs/themes/prism-solarizedlight.css")